// * COMMENT STORE MODULE
const comment_store = {
    namespaced: true, //to be case sencitive
    // * STATE
    state: {
        comment: { 
            show: false,
            action: 'New',     
            data: {
                id: '', // existing id if editing comment
                comment: '', // comment
                docLink: {
                    collection: '', // collection name related to comment 
                    documentId: '', // collection document Id related to comment
                }
            } 
            // editItem: [] 
        },
        commentResult: {
            collection: '',
            id: '',
            value: '',
        } // date will be returned here
    },
    // * MUTATIONS
    mutations:{
        MUT_comment(state, data) { state.comment = data },
        MUT_commentResult(state, data) { state.commentResult = data },
    },
    // * GETTERS
    getters:{
        GET_comment(state) { return state.comment },
        GET_commentResult(state) { return state.commentResult }
    },
    // * ACTIONS
    actions: {
        ACT_comment({commit}, payload){ commit('MUT_comment', payload) },
        ACT_commentResult({commit}, payload){ commit('MUT_commentResult', payload) },
    }
};
export default comment_store;